import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import RightArrow from '../../components/SVG';

import signInImg from '../../assets/img/contact/signin.jpg';


const SignInMain = () => {
  return (
    <main>

      <div className="it-signup-area pt-50 pb-50">
        <div className="container">
          <div className=" p-relative">
            <div className="it-signup-thumb d-none d-lg-block">
              <img src={signInImg} alt="" />
            </div>
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <form action="#">
                  <div className="it-signup-wrap">
                    <h4 className="it-signup-title">Change Password</h4>
                    <div className="it-signup-input-wrap">
                      <div className="it-signup-input mb-20">
                        <input type="email" placeholder="Old Password" style={{border:"1px solid black",borderRadius:"10px"}} />
                      </div>
                      <div className="it-signup-input mb-20">
                        <input type="password" placeholder="New Password" style={{border:"1px solid black",borderRadius:"10px"}} />
                      </div>
                      <div className="it-signup-input mb-20">
                        <input type="password" placeholder="Confirm Password" style={{border:"1px solid black",borderRadius:"10px"}} />
                      </div>
                    </div>
                    <div className="it-signup-btn d-sm-flex justify-content-between align-items-center mb-40">
                      <button type="submit" className="ed-btn-theme">
                        Change Password
                        <i>
                          <RightArrow />
                        </i>
                      </button>

                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SignInMain;
